import React from 'react'
import js from '../../assets/js.png'
import html from '../../assets/html.png'
import css from '../../assets/css.png'
import bootstrap from '../../assets/bootstrap.png'
import tailwindcss from '../../assets/tailwindcss.png'
import react from '../../assets/react.png'
import { Progress } from './Progress'


import './skill.css'

export const Frontend = () => {
    return (
        <div className='mt-4'>
            <div className='mb-4 d-flex '>
                <img src={html} alt='html' className='ms-3 ' />
                <div className='ms-3'>
                    <Progress done="90" />

                </div>
            </div>
            <div className='mb-4 d-flex'>
                <img src={css} alt='css' className='ms-3 ' />
                <div className='ms-3'>
                    <Progress done="85" />

                </div>
            </div>
            <div className='mb-4 d-flex'>
                <img src={js} alt='js' className='ms-3 ' />
                <div className='ms-3'>
                    <Progress done="65" />

                </div>
            </div>

            <div className='mb-4 d-flex'>
                <img src={bootstrap} alt='bootstrap' className='ms-3 ' />
                <div className='ms-3'>
                    <Progress done="95" />

                </div>

            </div>

            <div className='mb-4 d-flex'>
                <img src={tailwindcss} alt='tailwindcss' className='ms-3 ' />
                <div className='ms-3'>
                    <Progress done="90" />

                </div>

            </div>

            <div className='mb-4 d-flex '>
                <img src={react} alt='react' className='ms-3 ' />
                <div className='ms-3'>
                    <Progress done="85" />

                </div>

            </div>




        </div>
    )
}
